import React from 'react';
import styled from 'styled-components';
import { Button } from '../../../../../styles/theme/default/buttons';

const Wrapper = styled.div`
  width: 100%;
  position: fixed;
  bottom: 0;
  left: 0;
  button {
    width: 100%;
  }
`;

function ShowResultsButton({ totalFabricResults, toggle }) {
  return (
    <Wrapper>
      <Button onClick={toggle} dark={true}>
        Show {totalFabricResults} Results
      </Button>
    </Wrapper>
  );
}

export default ShowResultsButton;
